import React, {useEffect, useState} from 'react'
import {Table, Switch, message, Modal} from 'antd'
import {ExclamationCircleTwoTone} from '@ant-design/icons';
import {inject, observer} from 'mobx-react'
import cs from 'classnames'
import {listSwitchGroup, updateRegionTaskStatus, batchSwitchListTurnOn, batchSwitchListTurnOff, getSwitchGroupList, updateSwitchStatus} from '@apis'
import moment from 'moment'
import centerBg from '../../../assets/img/mapBg1.png'

const weekMap = {
  0: '日',
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六'
}

const GroupManagement = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId, strongProjectId: projectId} = userInfo
    const [switchGroupList, setSwitchGroupList] = useState([])
    const [loading, setLoading] = useState(false)

    async function querySwitchGroupList() {
      const params = {
        brokerId,
        projectId,
        pageNo: 1,
        pageSize: 9999,
      }
      setLoading(true)
      const res = projectId ? await getSwitchGroupList(params) : await listSwitchGroup(params)
      setLoading(false)
      if (res) {
        setSwitchGroupList(res.data.filter(item => item.show == true))
      }
    }

    //定时状态控制
    async function taskUpdate(record, status) {
      const params = {
        id:record.id,
        taskStatus:status
      }
      const res = await updateRegionTaskStatus(params)
      if (res) {
        message.success('操作成功')
        querySwitchGroupList()
      }
    }

    // 开关控制
    async function groupUpdate(record, status) {
      let res
      if(projectId) {
        const params = {
          id:record.id,
          switchStatus:status
        }
        res = await updateSwitchStatus(params)
      } else {
        const params = {
          brokerId: brokerId,
          lstSwicth: record.listSwitchInfo
        }
        res = status ? await batchSwitchListTurnOn(params) : await batchSwitchListTurnOff(params)
      }
      if (res) {
        message.success('操作成功')
        querySwitchGroupList()
      }
    }

    function remind(record, status) {
      const name = projectId ? record.switchGroupName : record.groupName
      Modal.confirm({
        title: '提示',
        icon: <ExclamationCircleTwoTone />,
        content: status ? '是否开启分组'+ name +'的开关？' : '是否关闭分组'+ name +'的开关？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          groupUpdate(record, status)
        }
      });
    }

    useEffect(() => {
      querySwitchGroupList()
    }, [])

    const columns = [{
      title: '编号',
      key: projectId ? 'id' : 'groupId',
      dataIndex: projectId ? 'id' : 'groupId',
    }, {
      title: '分组名称',
      key: projectId ? 'switchGroupName' : 'groupName',
      dataIndex: projectId ? 'switchGroupName' : 'groupName',
    }, {
      title: '定时状态',
      key: 'taskStatus',
      render: row => {
        return (
          <Switch
            checked={row.taskStatus === true}
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={e => {
              if(row.times[0].endTime <= 57600000) return message.warn('请先设置定时开启时间！')
              taskUpdate(row, e)
            }}
          />
        )
      },
    }, {
      title: '定时开启时间',
      key: 'times',
      render: row => {
        return row.times && row.times[0].endTime > 57600000 ? (
          <React.Fragment>
            {
              (row.times || []).map(item => (
                <div className="info-sp">
                  {moment(Number(item.startTime)).format('HH:mm:ss')}
                  <span style={{padding: '0 10px'}}>-</span>
                  {moment(Number(item.endTime)).format('HH:mm:ss')}
                </div>
              ))
            }
          </React.Fragment>
        ) : <div>暂无</div>
      }
    }, {
      title: '播放日期',
      key: 'dates',
      render: row => {
        return row.times && row.times[0].endTime > 57600000 ? (
          row.taskRate == 1 ? <React.Fragment>
            {
              <div className="info-sp">
                {moment(Number(row.dates[0])).format('YYYY.MM.DD')}
                <span style={{padding: '0 10px'}}>-</span>
                {moment(Number(row.dates[1])).format('YYYY.MM.DD')}
              </div>
            }
          </React.Fragment> :
            (
              <React.Fragment>
                周
                {
                  (row.dates || []).map(item => weekMap[item]).join()
                }
              </React.Fragment>
            )
        ) : <div>暂无</div>
      }
    }, {
      title: '状态',
      key: projectId ? 'switchStatus' : 'switchAllStatus',
      dataIndex: projectId ? 'switchStatus' : 'switchAllStatus',
      render: text => {
        return (
          <span
            className={
              cs({
                "sp-online": true,
                'sp-green': text == true,
                'sp-red': text == false,
              })
            }
          >
            {
              text == true ? '开启' : '关闭'
            }
          </span>
        )
      },
    }, {
      title: '开关',
      key: 'switch',
      render: row => {
        return (
          <Switch
            checked={projectId ? row.switchStatus : row.switchAllStatus == true}
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={e => {
              remind(row, e)
            }}
          />
        )
      }
    }]

    return (
      <React.Fragment>
        <img src={centerBg} className='group-img'/>
        <Table
          className='group-table'
          title={() => '回路管理'}
          columns={columns}
          dataSource={switchGroupList}
          loading={loading}
          pagination={{
            position: ['topRight'],
            showSizeChanger: false
          }}
        />
      </React.Fragment>
    )
  })
)

export default GroupManagement
